import { z } from "zod";
import { IdSchema } from "./common.js";
import { MAIL_TYPES } from "../constants/index.js";

/**
 * 진실의 원천: harness/API-SPEC.md §9, harness/MAIL-TEMPLATE.md
 */

export const MailDraftRequestSchema = z.object({
  case_ids: z.array(IdSchema).min(1).max(100), // 반증 RT-9
  type: z.enum(MAIL_TYPES),
});
export type MailDraftRequest = z.infer<typeof MailDraftRequestSchema>;

export const MailDraftSchema = z.object({
  type: z.enum(MAIL_TYPES),
  subject: z.string(),
  body_text: z.string(),
  // 그룹웨어 편집기에 붙여넣기용. 표가 실제 보내는 메일과 같아 보여야 쉬워진 것이다
  body_html: z.string(),
  // 빠진 건·출고 없는 건을 **말해 준다.** 조용히 빠뜨리면 보고에서 누락된 줄 모른다
  warnings: z.array(z.string()),
  // 발송하지 않는다 — 초안 반환뿐 (harness/AGENT.md B4)
});
export type MailDraft = z.infer<typeof MailDraftSchema>;
